import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'

const skin = era.skin('widgets/Popups/SignInToWatchPopup/')

SignInToWatchPopup.displayName = 'SignInToWatchPopup'
export function SignInToWatchPopup(): JSX.Element | null {
  return <ui.RenderSkin from={skin} name='signInToWatchPopup' />
}
